import React, { useEffect, useState } from "react";
import HeaderDashboard from '../../Components/HeaderDashboard';



const AgencyInvoice = () => {

    
const handlePrint = () => {
  const pdfUrl = "/Reservations/Flight/PrintInvoice"; 
  const win = window.open(pdfUrl);
  win.onload = () => {
    win.print();
  };
};

    return(
       <>
       <HeaderDashboard></HeaderDashboard>
  <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Agency Invoice</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="Reservations/Flight/AgencyInvoice" className="text-muted text-hover-primary">Agency Invoice</a>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        
         <section className='wraper'>
           <div className='box_shadow mt-14'>
                <div className='row'>
                    <div className='col-md-6'>
                        <img src="/assets/images/logo.png" width={"200px"}></img>
                    </div>
                    <div className='col-md-6'>
                         <ul class="option_s">
                            
                                    <li><a href="#" onClick={handlePrint} data-bs-toggle="tooltip" title="Print Ticket"> <img src="/assets/images/flight/printer.png" alt="train" /></a></li>
                                     <li><a href="" data-bs-toggle="tooltip" title="PNR Status"><img src="/assets/images/flight/download.png" alt="train" /></a></li>
                                    
                                </ul>
                       <div className="ib_numbr">
                        <p> Invoice Date : <strong>17/12/2025</strong> </p>
                        <p> VAT Invoice and Number: <strong>65665</strong> </p>
                      
                       </div>
                    </div>
                   <div className="ro mt-5">
                     <div className='col-md-6 p-0'>
                       <div className="from_top">
                         <h6>From</h6>
                         <div class="d-flexs">
                            <div class="lablx">Company Details</div>
                            <div class="labl_detls">test</div>
                        </div>
                        
                         <div class="d-flexs">
                            <div class="lablx">Email</div>
                            <div class="labl_detls">test</div>
                        </div>
                         <div class="d-flexs">
                            <div class="lablx">Phone</div>
                            <div class="labl_detls">test</div>
                        </div>
                       
                         <div class="d-flexs">
                            <div class="lablx">Regd Office</div>
                            <div class="labl_detls">test</div>
                        </div>
                       </div>
                        
                    </div>
                    <div className='col-md-6 p-0'>
                       <div className="from_tod">
                         <h6>To</h6>
                         <div class="d-flexs">
                            <div class="lablx">Company Name</div>
                            <div class="labl_detls">test</div>
                        </div>
                         <div class="d-flexs">
                            <div class="lablx">Email</div>
                            <div class="labl_detls">test</div>
                        </div>
                         <div class="d-flexs">
                            <div class="lablx">Phone</div>
                            <div class="labl_detls">test</div>
                        </div>
                         <div class="d-flexs">
                            <div class="lablx">Address</div>
                            <div class="labl_detls">test</div>
                        </div>
                       </div>
                        
                    </div>
                   </div>
                   
                    <div className='col-md-12 mt-5'>
                         <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>S No.</th>
                                <th>Ticket No.</th>
                                <th>PNR No.</th>
                                <th>Sectors</th>
                                <th>Flight</th>
                                <th>PAX Name</th>
                                <th>Travel Date</th>
                                <th>Base Fare</th>
                                <th>OT Tax</th>
                                <th>YQ Tax</th>
                                <th>Baggage Charges</th>
                                <th>Meal Charges</th>
                                <th>Seat Charges</th>
                                <th>Booking Surcharge</th>
                                <th>Booking Surcharge Tax</th>
                                </tr>
                            </thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                         </table>
                    </div>
                   
                </div>
                <div className="row">
                    <div className='col-md-12'>
                        <h6>GST Details</h6>
                         <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Description</th>
                                    <td>CGST@9%</td>
                                    <td>SGST@9%</td>
                                    <td>IGST@18%</td>
                                </tr>
                            </thead>
                                <tbody>
                                    <tr>
                                    <th>Booking Surcharge GST</th>
                                    <td>0.00</td>
                                    <td>0.00</td>
                                    <td>0.00</td>
                                    </tr>
                                </tbody>
                         </table>
                    </div>
                    <div className='col-md-12'>
                        <h6>Grass Payment</h6>
                         <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Grass</th>
                                    <th>8335.3</th>
                                </tr>
                            </thead>
                                <tbody>
                                    <tr>
                                        <td>Flight Commission Earned</td>
                                        <td>70.0</td>
                                    </tr>
                                    <tr>
                                        <td>Flight TDS Detucted</td>
                                        <td>0.0</td>
                                    </tr>
                                     <tr>
                                    <th>Net Amount:</th>
                                    <th><i className="fa fa-inr"></i>1335.3</th>
                                </tr>
                                </tbody>
                         </table>
                    </div>
                    <div className='col-md-12'>
                        <h6>Terms & Conditions</h6>
                         <p> <strong>IMP</strong> : All cases & disputed and subject to Mumbai Jurisdiction.</p>
                         <p> <strong>IMP</strong> : Refund % cancellations are subject to Airlines approval.</p>
                         <p> <strong>Cheque</strong> : Must be drawn in favour of Berry Journey.</p>
                         <p> <strong>Late Payment</strong> : Interest @24% per annum will be charged on all outstanding bills after due date.</p>
                    </div>
                </div>
            </div>

        </section>
        </>
    )
};

export default AgencyInvoice;